import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    adminData: {
        caseId: "",
        isAdmin: false,
        formId: "",
        loanPurposeId: "",
    }
};
export var caseIdFromUrlSlice = createSlice({
    name: 'admin',
    initialState: initialState,
    reducers: {
        useCaseId: function (state, action) {
            // use object too for assign the payload
            state.adminData.caseId = action.payload.caseId;
            state.adminData.formId = action.payload.formId;
            state.adminData.isAdmin = action.payload.isAdmin;
            state.adminData.loanPurposeId = action.payload.loanPurposeId;
        },
    }
});
export var useCaseId = caseIdFromUrlSlice.actions.useCaseId;
export default caseIdFromUrlSlice.reducer;
